export enum SettlementPaymentTypeEnum {
    PRZELEW = 1,
    GOTOWKA = 2,
    KOMPENSATA = 3,
    KARTAPLATNICZA = 4,
    PLATNOSCPOZASYSTEMEM = 5,
}
